import { React } from '_core';

import { PreferencesContextProvider } from 'views/preferences/preferences-context';

import Preferences from './preferences';

const PreferencesIndex = () => (
  <PreferencesContextProvider>
    <Preferences />
  </PreferencesContextProvider>
);

export default PreferencesIndex;
